export const PRINT_WORKSHEET_MODAL = 'printWorksheetModal';
